import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  CreateProcessoArbitralPayload,
  CreateProcessoArbitralResponse,
  ProcessoInicioFluxoStatus,
  SubmitProcessoArbitralError,
} from '@/features/processo-arbitral/types/submissaoStepTypes';
import { getErrorMessage } from '@/shared/utils/error';

import { SubmissaoApiError, submissaoStepService } from './services';

export const submitProcessoArbitral = createAsyncThunk<
  CreateProcessoArbitralResponse,
  CreateProcessoArbitralPayload,
  { rejectValue: SubmitProcessoArbitralError }
>('processoArbitral/submissaoStep/submitProcessoArbitral', async (payload, { rejectWithValue }) => {
  try {
    return await submissaoStepService.createProcessoArbitral(payload);
  } catch (error) {
    if (error instanceof SubmissaoApiError) {
      return rejectWithValue({ message: error.message, code: error.code });
    }
    return rejectWithValue({ message: getErrorMessage(error) });
  }
});

export const fetchProcessoInicioFluxoStatus = createAsyncThunk<
  ProcessoInicioFluxoStatus,
  string,
  { rejectValue: string }
>(
  'processoArbitral/submissaoStep/fetchInicioFluxoStatus',
  async (processoId, { rejectWithValue }) => {
    try {
      return await submissaoStepService.getProcessoInicioFluxo(processoId);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
